import { pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { T } from "./score-condition-value-input.i18n";

type ScoreConditionValueInputProps = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  /** The mode's or quiz's pass bar, in points. Null when the source is gone. */
  passScore: number | null;
  /** UI language of the surrounding dialog. */
  language: string;
  disabled?: boolean;
};

export function ScoreConditionValueInput({
  id,
  value,
  onChange,
  passScore,
  language,
  disabled,
}: ScoreConditionValueInputProps) {
  const t = pickT(T, language);
  return (
    <div className="space-y-1">
      <Input
        id={id}
        type="number"
        inputMode="decimal"
        step="any"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t.placeholder}
        disabled={disabled}
      />
      {passScore !== null && (
        <p className="text-xs text-muted-foreground">{t.passScoreHint(String(passScore))}</p>
      )}
    </div>
  );
}
